<template>
  <div class="main-page page-video-home">
    <HomeHead :show="false" />
    <div class="demo-panel__content container-flex grayscale">
      <div class="c-left">
        <PufaVideo height="4.78rem" width="8.92rem" />
        <VideoConsult class="mt-14" height="1.5rem" :bg="vConsult.bg" width="8.92rem" :item="vConsult" />
        <div class="ai-lawyer" @click="toAiLawyer">
          <div class="imgs">
            <img src="https://qiniu.laway.cn/yn/2023/10/10/ae571c3c671811ee9d56b4055d0b07be.png" alt="">
          </div>
          <div class="intro">
            <div class="title">AI智能律师在线咨询</div>
            <div class="desc">人工智能律师，对话式问答，24小时在线</div>
          </div>
        </div>

      </div>
      <div class="block-panel  ">
        <div class="item-panel">
          <q-link :item="advisory" width="4.4rem" :show-desc="true" height="3.14rem" class="c8 mb-14 flex-col text-center" />
          <q-link :item="swflfw" width="4.4rem" :show-desc="true" height="3.14rem" class="c12 mb-14 flex-col text-center foreign-service-entry">
            <div slot="badge" class="foreign-service-badge"><span>新增</span></div>
          </q-link>
          <q-link :item="wenshu" width="4.4rem" :show-desc="true" height="3.14rem" class="c9  mb-14 flex-col text-center" />
          <div>
            <q-link :item="liuyan" width="4.4rem" :show-desc="true" height="1.49rem" class="c12  mb-14 " />
            <q-link :item="qsz" width="4.4rem" :show-desc="true" height="1.49rem" class="c10  mb-14 " />
          </div>
          <div @click="dialogVisible = true">
            <q-link :item="cxfw" width="4.4rem" :show-desc="true" height="1.49rem" class="c12  mb-14 " />
          </div>
          <q-link :item="allservice" width="4.4rem" :show-desc="true" height="1.49rem" class="c11  mb-14 " />
        </div>
      </div>

    </div>
    <HomeFoot />
    <el-dialog title="查询服务" show-close center :visible.sync="dialogVisible" width="15.84rem" custom-class="service-dialog">
      <div class="item-panel">
        <div class="item" @click="toLink(v)" v-for="(v, index) in list" :key="'keys' + index">
          <div class="icon" :style="`background-color:${v.color} ;`">
            <i :class="'iconfont ' + v.img"></i>
          </div>
          <div class="title">{{ v.name }}</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import HomeHead from '@/components/home/HomeHead'
import HomeFoot from '@/components/home/HomeFoot'
import VideoConsult from '@/components/home/VideoConsult'
import PufaVideo from '@/components/home/PufaVideo'
import QLink from '@/components/home/QLink'
import { LAW_INQUIRE } from '@/datas/constants/statistics'

export default {
  components: {
    HomeHead,
    HomeFoot,
    VideoConsult,
    PufaVideo,
    QLink,
  },
  data () {
    return {
      vConsult: {
        icon: 'https://qiniu.laway.cn/yn/2023/10/10/e9a681ec671811ee9d56b4055d0b07be.png',
        title: '连线人工律师',
        desc: '实时视频连线人工律师，真人在线解答法律问题',
        path: '/video',
        bg: 'linear-gradient(-180deg,#505efa 0%,	#6e79f8 100%)'
      },
      qsz: {
        title: "智能要素式起诉状/答辩状",
        path: "/indictment",
        icon: "https://qiniu.laway.cn/yn/2025/06/13/2e0d96ac483811f0a97fb4055d0b07be.png"
      },
      advisory: {
        title: '精准法律咨询',
        desc: '提供精准咨询，生成专业法律意见书',
        advisory: true,
        icon: 'https://qiniu.laway.cn/yn/2023/10/10/321ee488671811ee9d56b4055d0b07be.png'
      },
      wenshu: {
        title: '文书模板下载',
        desc: '智能文书在线生成，合同/文书模板下载',
        icon: 'https://qiniu.laway.cn/yn/2023/10/10/017ff724672011ee9d56b4055d0b07be.png',
        path: '/service/11?title=文书模板下载'
      },
      liuyan: {
        icon: 'https://qiniu.laway.cn/yn/2023/10/10/6663794e672111ee9d56b4055d0b07be.png',
        title: '留言咨询',
        desc: '通过留言进行咨询，律师将会解答',
        path: '/service/10'
      },
      cxfw: {
        icon: 'https://qiniu.laway.cn/yn/2023/10/10/93a133bc673311ee9d56b4055d0b07be.png',
        title: '查询服务',
        desc: '查询法律服务机构、法律法规等'
      },
      allservice: {
        icon: 'https://qiniu.laway.cn/yn/2023/10/10/d4d4d248673411ee9d56b4055d0b07be.png',
        title: '查看所有服务',
        desc: '法律业务办理、以案释法、法治宣传等',
        path: '/allservice'
      },
      dialogVisible: false,
      list: [
        {
          name: '法律法规查询',
          color: '#ff793f',
          img: 'iconfalvfagui',
          outerlink: `${this.$store.state.app.appSite}/cus/law-ter/law?code=${this.$store.state.device.point.code}&machineId=${this.$store.state.device.point.no}`,
          statistics: LAW_INQUIRE
        },
        {
          name: '律所查询',
          color: '#4d82e9',
          img: 'iconlvsuochaxun',
          url: '/flsearch/2'
        },
        {
          name: '律师查询',
          color: '#fd773e;',
          img: 'iconlvshi',
          url: '/flsearch/1'
        },
        {
          name: '经典案例',
          color: '#33c366',
          img: 'iconyunshuhetong',
          url: '/caselibrary'
        },
        {
          name: '案例库查询',
          color: '#4d82e9',
          img: 'iconanlichakan',
          url: '/case'
        },
        {
          url: '/map/7',
          name: '法律援助机构',
          img: 'iconfalvyuanzhugongzuozhan',
          color: '#8f81e2',
        },
        {
          url: '/map/2',
          name: '人民调解委员会',
          img: 'icontiaoweihuichaxun',
          color: '#fc9d0b'
        },
        {
          url: '/map/6',
          name: '法律服务所',
          img: 'iconfalvfuwusuo',
          color: '#508fff'
        },
        {
          url: '/map/4',
          name: '司法所',
          img: 'iconfayuan',
          color: '#8f81e2'
        },
        {
          url: '/map/5',
          name: '公证处',
          img: 'icongongzhengchu',
          color: '#fc9d0b'
        },
        {
          url: '/map/1',
          name: '司法鉴定机构',
          img: 'iconsifajianding',
          color: '#4d82e9'
        },
        {
          url: '/map/8',
          name: '公共法律服务中心',
          img: 'icongonggongfalvfuwuzhongxin',
          color: '#8f81e2'
        },
        {
          url: '/map/9',
          name: '仲裁机构',
          img: 'iconzhongcai',
          color: '#33c366'
        }
      ],
      swflfw: {
        icon: 'https://yn.12348.laway.cn/los/art_img/202601/fe76a928f76511f0a3c0b4055d0b0812.png',
        title: '涉外法律服务',
        desc: '涉外法治服务解决方案',
        path: '/dnaservice'
      }
    }
  },
  async created () {
    const StateDevice = this.$store.state.device
    if (!StateDevice.point) {
      await this.$store.dispatch('device/getData')
    }
    if (!StateDevice.point.geography) {
      this.$router.push('/initial')
    }

  },
  mounted () {
    if (!this.appList.length) {
      this.$store.dispatch('app/getAppList')
    }
  },
  methods: {
    toLink (item) {
      if (item.url) {
        this.$router.push(item.url)
      }
      if (item.outerlink) {
        if (item.statistics) {
          this.$root.getStatistics(item.statistics)
          window.location.href = item.outerlink
        }
      }
    },
  }
}
</script>


<style lang="stylus" scoped>
.foreign-service-entry
  position relative
  .foreign-service-badge
    position absolute
    top 0
    right 0
    width 0.85rem
    height 0.85rem
    background url('https://qiniu.laway.cn/publaw/350e18e6c92e11f19d5bfa2800184358.png') no-repeat right top / contain
    pointer-events none
    span
      position absolute
      top 0.12rem
      right 0.08rem
      color #fff
      font-size 0.16rem
      font-weight bold
      line-height 1.2

.page-video-home
  position relative
  box-sizing border-box
  padding 0.1rem 0 0.28rem
  overflow hidden
  .mt-14
    margin-top 0.14rem
  .ml-14
    margin-left 0.14rem
  .mb-14
    margin-bottom 0.14rem
  .mr-14
    margin-right 0.14rem
    border-radius 0.08rem
  .demo-panel__content
    display flex
    padding 0.18rem 0.53rem 0 0.6rem
    justify-content space-between
    color #fff
    font-size 0.2rem
    .c-left
      width 8.92rem
      /deep/ .home-video-consult
        flex-direction row
        justify-content start
        padding-left 1.3rem
        img
          width 1.2rem
          margin 0 0.1rem 0 0
        .title
          font-size 0.24rem
        .desc
          font-size 0.16rem
          margin-top 0.1rem
      .ai-lawyer
        display flex
        height 1.49rem
        background-color #347cff
        margin 0.14rem 0
        padding-left 1.3rem
        align-items center
        .imgs
          width 1.2rem
          height 1.2rem
          margin-right 0.1rem
          img
            width 1.2rem
        .intro
          .title
            font-size 0.24rem
          .desc
            font-size 0.16rem
            margin-top 0.1rem
    .block-panel
      flex 1
      margin-left 0.07rem
      .item-panel
        display flex
        flex-wrap wrap
    /deep/ .q-link-item
      margin-left 0.07rem
      margin-right 0.07rem
      .title
        font-size 0.24rem
      .desc
        font-size 0.16rem
        margin-top 0.1rem
      &.c11
        img
          margin-bottom 0
/deep/.service-dialog
  border-radius 10px
  .el-dialog__header
    padding-top 0.48rem
  .el-dialog__title
    font-size 0.3rem
    font-weight bold
  .el-icon-close
    color #ccc
    font-size 0.5rem
  .item-panel
    display flex
    flex-wrap wrap
    text-align center
    padding-top 0.25rem
    .item
      width 2rem
      margin-bottom 0.8rem
    .icon
      width 0.9rem
      height 0.9rem
      line-height 0.9rem
      border-radius 50%
      margin 0 auto 0.2rem
      color #ffff
      i
        font-size 0.5rem
    .title
      color #333
      font-size 0.24rem
</style>
